import React from "react";
import { marqueeTreatments } from "../mock/data";

export default function Marquee() {
  const items = [...marqueeTreatments, ...marqueeTreatments];
  return (
    <section aria-label="Treatments marquee" className="py-6 border-y border-[#0e2b2b]/10 bg-[#f6f7f4] overflow-hidden">
      <div className="marquee-track flex gap-3 whitespace-nowrap w-max overflow-hidden">
        {items.map((t, i) => (
          <span key={i} className="inline-flex items-center px-5 py-2.5 rounded-full bg-white border border-[#0e2b2b]/10 text-[13px] text-[#0e2b2b]/80 hover:border-[#14a68e]/50 hover:text-[#14a68e] transition">
            {t}
          </span>
        ))}
      </div>
    </section>
  );
}
